var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"airwallex_box"},[_c('div',{style:({ display: 'block' }),attrs:{"id":"dropIn"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }